module.exports = __webpack_public_path__ + "img/Group6.1ba89995.png";